import { Divider, Input, InputNumber, Row } from "antd";
import { FormItem } from "common/components/form/FormItem";
import { ComplementModel } from "api/generated";
import ResponsiveCol from "common/components/form/ResponsiveCol";
import { ExtraInfoBtn } from "common/helpers/generalUtils";
import {
  patternpermisoTransporteCRE,
  validateCantidadMonetaria,
} from "services/utils/patterns";

export function TransportComplementForm() {
  return (
    <div>
      <Divider
        orientation="left"
        style={{ fontSize: "15px", borderColor: "#49f5f5ff" }}
      >
        Complemento - Transporte
      </Divider>
      <Row gutter={24}>
        <FormItem<ComplementModel>
          hidden
          label="transport_id"
          name={["transport", "id"]}
        />

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Número de permiso"
            name={["transport", "permission"]}
            rules={[
              { required: true, message: "Este campo es obligatorio" },
              {
                pattern: patternpermisoTransporteCRE,
                message: "El valor ingresado no tiene un formato valido",
              },
            ]}
          >
            <Input
              className="common-input"
              placeholder="PermisoTransporte"
              addonAfter={ExtraInfoBtn("Número de permiso", [
                "Debes registrar el número de permiso otorgado por la Comisión Reguladora de Energía a la persona que contrataste para el transporte del producto.",
                "Ejemplo: PermisoTransporte = PL/99990/TRA/DUC/2030",
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Clave de Vehículo"
            name={["transport", "vehicleKey"]}
            rules={[
              {
                min: 6,
                message: "Introduce mínimo 6 caracteres.",
              },
              {
                max: 12,
                message: "No se puede exceder los 12 caracteres.",
              },
            ]}
          >
            <Input
              className="common-input"
              placeholder="ClaveDeVehiculo"
              addonAfter={ExtraInfoBtn("Número económico o número de placa", [
                "La presencia de este elemento es opcional y debes registrar el número económico o el número de placa cuando el servicio de transporte que hayas contratado sea por medios distintos a ductos, en caso contrario no deberá existir.",
                "Ejemplo: ClaveDeVehiculo = 456TRD",
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Tarifa de Transporte"
            name={["transport", "tariffAmount"]}
            rules={[
              { required: true, message: "Este campo es obligatorio" },
              {
                validator: validateCantidadMonetaria,
              },
            ]}
          >
            <InputNumber
              className="common-input"
              placeholder="TarifaDeTransporte"
              prefix="$"
              suffix="mxn"
              precision={5}
              addonAfter={ExtraInfoBtn("Tarifa por el servicio de transporte", [
                "Debes registrar, en pesos mexicanos la tarifa determinada por la Comisión Reguladora de Energía, que te cobraron por el servicio de transporte.",
                "En caso de que no se haya cobrado la tarifa, deberá manifestarse 0",
                "TarifaDeTransporte = 4.46500",
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Cargo por Capacidad"
            name={["transport", "ductCapacityAmount"]}
            rules={[
              {
                validator: validateCantidadMonetaria,
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              prefix="$"
              suffix="mxn"
              precision={5}
              className="common-input"
              placeholder="CargoPorCapacidadTrans"
              addonAfter={ExtraInfoBtn("Cargo por capacidad", [
                "La presencia de este elemento es opcional y debes registrar el cargo, determinado por la Comisión Reguladora de Energía, por capacidad cobrado, en pesos mexicanos y sin impuestos, por día, para reservar capacidad para transportar diariamente por medio de ductos, en caso contrario no deberá existir.",
                "CargoPorCapacidadTrans = 0.99200",
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Cargo por Uso"
            name={["transport", "ductUseAmount"]}
            rules={[
              {
                validator: validateCantidadMonetaria,
              },
            ]}
          >
            <InputNumber
              prefix="$"
              suffix="mxn"
              precision={5}
              style={{ width: "100%" }}
              className="common-input"
              placeholder="CargoPorUsoTrans"
              addonAfter={ExtraInfoBtn("Cargo por uso", [
                "La presencia de este elemento es opcional y debes registrar el cargo, determinado por la Comisión Reguladora de Energía, por uso por el servicio de entregar un barril a través del sistema de transporte cobrado, en pesos mexicanos y sin impuestos, por día, cuando el servicio de transporte que hayas contratado sea por medios de ductos, en caso contrario no deberá existir.",
                "CargoPorUsoTrans = 0.03600",
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Cargo Volumetrico"
            name={["transport", "ductVolumetricAmount"]}
            rules={[
              {
                validator: validateCantidadMonetaria,
              },
            ]}
          >
            <InputNumber
              prefix="$"
              suffix="mxn"
              precision={5}
              style={{ width: "100%" }}
              className="common-input"
              placeholder="CargoVolumetricoTrans"
              addonAfter={ExtraInfoBtn("Cargo único volumétrico", [
                "La presencia de este elemento es opcional y debes registrar el cargo, determinado por la Comisión Reguladora de Energía, único volumétrico del transporte por el servicio de transportar un barril a través del sistema de transporte cobrado, en pesos mexicanos y sin impuestos, por día, de transporte cuando el servicio de transporte que hayas contratado sea por medio de ductos, en caso contrario no deberá existir.",
                "CargoVolumetricoTrans = 3.43700",
              ])}
            />
          </FormItem>
        </ResponsiveCol>

        <ResponsiveCol>
          <FormItem<ComplementModel>
            label="Tarifa de Suministro"
            name={["transport", "supplyAmount"]}
            rules={[
              {
                validator: validateCantidadMonetaria,
              },
            ]}
          >
            <InputNumber
              prefix="$"
              suffix="mxn"
              precision={5}
              style={{ width: "100%" }}
              className="common-input"
              placeholder="TarifaDeSuministro"
              addonAfter={ExtraInfoBtn("Tarifa por el servicio de suministro", [
                "La presencia de este elemento es opcional y en su caso debes registrar la tarifa, determinada por la Comisión Reguladora de Energía, en pesos mexicanos, que pagaste por el servicio de suministro otorgado por un permisionario",
                "TarifaDeSuministro = 23.32200",
              ])}
            />
          </FormItem>
        </ResponsiveCol>
      </Row>
    </div>
  );
}
